import dishImage from '../../../../../../../../assets/images/food-mock.png';
import { Button } from '../../../../../../../../components/button/button';
import { Container } from '../../../../../../../../components/container/container';
import { InputFileSquare } from '../../../../../../../../components/input-file/input-file-square/input-file-square';
import { Input } from '../../../../../../../../components/input/input';
import { Label } from '../../../../../../../../components/label/label';
import { Select } from '../../../../../../../../components/select/select';
import { LangInput } from '../../../../../../../../features/lang-input/lang-input';
import { MultiSelect } from '../../../../../../../../features/multi-select/multi-select';
import { WorkingHoursModal } from '../../../../../../../../features/working-hours/working-hours-modal/working-hours-modal';
import s from './menu-informer-create-menu-modal-step-1.module.css';
import { useMenuInformerCreateMenuModalStep1 } from './use-menu-informer-create-menu-modal-step-1';

export const MenuInformerCreateMenuModalStep1 = () => {
  const {
    addError,
    tags,
    handleChangePhoto,
    handleUpdateMenu,
    isLoadingImage,
    menu,
    availableQrs,
    selectedQrs,
    selectedTags,
    t,
    branchIdValues,
    handleSelectBranch,
    open,
    setOpen,
    handleSave,
    branchId,
  } = useMenuInformerCreateMenuModalStep1();

  return (
    <div className={s.feature}>
      <Label label={t('Логотип меню, рекомендуемое разрешение 128х128 (не более 1Мб)')} />
      <InputFileSquare
        data-testid="logo-input"
        types={['image/*']}
        onChange={handleChangePhoto}
        src={menu?.images?.main?.thumbnail || menu?.images?.main?.normal || dishImage}
        wrapperClassName={s.image}
        isLoading={isLoadingImage}
        deletable={!!menu?.images?.main?.thumbnail || !!menu?.images?.main?.normal}
        maxFileSizeInMb={1}
        onFileSizeError={() =>
          addError({
            label: t('Файл не должен превышать 1Мб'),
            variant: 'danger',
          })
        }
      />
      <Container label={t('Название')} required>
        <LangInput
          data-testid="name-input"
          name="name"
          showLanguageSelect={false}
          value={menu?.name}
          onChange={(e) => handleUpdateMenu({ name: e })}
        />
      </Container>

      <Container label={t('Время на принятие заказа сотрудником')} required>
        <Input
          data-testid="accept-minutes-input"
          value={menu?.accept_minutes}
          type="number"
          onChange={(e) => handleUpdateMenu({ accept_minutes: Number(e.currentTarget.value) })}
        />
      </Container>

      <Container label={t('Ответственные')}>
        <MultiSelect
          data-testid="responsible-input"
          options={tags}
          onSelect={(e) => handleUpdateMenu({ tag_ids: e.map((item) => Number(item.id)) })}
          value={selectedTags}
        />
      </Container>

      {!branchId && (
        <Container label={t('Филиал')} required>
          <Select
            data-testid="branch-input"
            options={branchIdValues}
            name="branch"
            onSelect={handleSelectBranch}
            value={branchIdValues.find((item) => Number(item.id) === menu?.place_id)}
          />
        </Container>
      )}
      <Container label={t('QR-коды')} required>
        <MultiSelect
          data-testid="qr-codes-input"
          name="codes"
          options={availableQrs}
          onSelect={(e) => handleUpdateMenu({ qr_ids: e.map((item) => String(item.id)) })}
          value={selectedQrs}
          disabled={!branchId}
        />
      </Container>

      <Button
        data-testid="working-hours-button"
        onClick={() => setOpen(true)}
        variant="secondary"
        disabled={!branchId || !menu?.qr_ids?.length}
      >
        {t('Установить время работы')}
      </Button>
      {open && (
        <WorkingHoursModal
          onClose={() => setOpen(false)}
          handleUpdateSpecs={(e) =>
            handleUpdateMenu({ working_hours: { ...menu?.working_hours, specs: e } })
          }
          handleUpdateWeek={(e) =>
            handleUpdateMenu({ working_hours: { ...menu?.working_hours, week: e } })
          }
          data={menu?.working_hours}
          onSave={handleSave}
        />
      )}
    </div>
  );
};
